import { createEffect, createStore } from "effector";

import { getStates } from "../../shared/api/states";

import { StatesStore } from "./types";
import { defaultState, statesArray } from "./utils";

export const $states = createStore<StatesStore>(defaultState);

export const getStatesFx = createEffect(getStates);
$states
  .on(getStatesFx.done, (store, response) => ({
    ...store,
    states: response.result.data.states,
  }))
  .on(getStatesFx.fail, (store) => ({
    ...store,
    states: statesArray,
  }))
  .on(getStatesFx.pending, (store, loading) => ({
    ...store,
    loading,
  }));
